import React from 'react'
import Navbar from '../component/landing/Navbar'
import Hero from '../component/landing/Hero'
import Description from '../component/landing/Description'
import About from '../component/landing/About'
// import Service from '../component/landing/Service'
import Benefit from '../component/landing/Benefit'
import Testimonials from '../component/landing/Testimonials'
import ContactUs from '../component/landing/ContactUs'
import Patners from '../component/landing/Patners'
import Footer from '../component/landing/Footer'
import Trivia from '../component/trivia/Trivia'



const LandingPage = () => {
    return (
        <div className='w-full h-fit bg-white '>
            <div>
                <Navbar />  
            </div>

            <div className='mt-16 lg:mt-24 w-full '>
            <Hero />
            </div>

            <div className='mt-16 lg:mt-24 w-full '>
            <Description />
            </div>

            <div className='mt-6 w-full' >
            <Trivia />
            </div>

            <div className='mt-6 w-full ' id='benefits'>
            <Benefit />
            </div>
            
            <div className='mt-10 w-full' id='about-us'>
            <About />
            </div>

            {/* <div className='mt-6 w-full ' id='services'>
            <Service />
            </div> */}

            

            <div className='mt-6 lg:mt-20 w-full ' >
            <Testimonials />
            </div>

            {/* <div className='mt-6 w-full '>
            <ContactUs />
            </div> */}

            <div className='mt-40 w-full '>
            <Patners />
            </div>

            <div className='mt-6 w-full '>
            <Footer />
            </div>

            
        </div>
    )
}

export default LandingPage
